import React from 'react'
import Button from '@mui/material/Button'
import './Buttons.css'

function BaseButton({ children, className = '', href, ...props }) {
  return (
    <Button
      className={`cnergi-button ${className}`.trim()}
      component={href ? 'a' : 'button'}
      disableElevation
      href={href}
      type={href ? undefined : 'button'}
      {...props}
    >
      {children}
    </Button>
  )
}

export function PrimaryButton({ children, className = '', ...props }) {
  return (
    <BaseButton className={`cnergi-button--primary ${className}`.trim()} {...props}>
      {children}
    </BaseButton>
  )
}

export function SecondaryButton({ children, className = '', ...props }) {
  return (
    <BaseButton className={`cnergi-button--secondary ${className}`.trim()} {...props}>
      {children}
    </BaseButton>
  )
}
